import { render, staticRenderFns } from "./PageSignUpPaymentConfirm.vue?vue&type=template&id=e97285b0&scoped=true"
import script from "./PageSignUpPaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PageSignUpPaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97285b0",
  null
  
)

export default component.exports